// @ts-nocheck
import React from 'react';
import { navigate } from '../../lib/routerAdapter';
import { licensePlateChangeCostApi } from './../../lib/api';
import CommonListPage from './../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';
import { withUserAccess } from './../withUserAccess';
import { Filter } from './components';
import { formatDateTimeToString } from '../../lib/helpers';
import { approveTypes } from '../../lib/enum';
import { getBreadCrumbsByUrl } from '../../lib/autoBreadcrumbs';
const entryPointPath = '/admin/license-plate-change-cost/';
const columns = [{
  title: '№ записи',
  dataIndex: 'id'
}, {
  title: 'Филиал',
  dataIndex: 'orgUnitName'
}, {
  title: 'Стоимость за одну замену без НДС, руб',
  dataIndex: 'cost'
}, {
  title: 'Дата начала',
  dataIndex: 'startDate',
  render: startDate => formatDateTimeToString(startDate, 'DD.MM.YYYY')
}, {
  title: 'Дата окончания',
  dataIndex: 'endDate',
  render: endDate => formatDateTimeToString(endDate, 'DD.MM.YYYY')
}, {
  title: 'Статус',
  dataIndex: 'status',
  render: status => approveTypes[status]
}];
const access = {
  add: () => navigate(`${entryPointPath}new`)
};
export default withUserAccess(({
  userAccess
}) => {
  const breadCrumbs = getBreadCrumbsByUrl(entryPointPath);
  return <Page>
      <CommonListPage crud={licensePlateChangeCostApi} pageHeaderProps={{
      breadCrumbs,
      mainHeader: 'Стоимость замены гос.номеров',
      access
    }} tableListProps={{
      columns,
      onSelect: id => navigate(`${entryPointPath}${id}`)
    }} filter={Filter} />
    </Page>;
});
